import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    fill="none"
    viewBox="0 0 14 13"
    {...props}
  >
    <path
      fill="#999"
      d="m.689 11.009 4.614-4.614-4.6-4.6L2.49.008l4.6 4.6L11.675.021l1.758 1.773-4.57 4.585 4.599 4.6-1.787 1.787-4.6-4.6-4.614 4.614z"
    />
  </svg>
);
export default SvgCloseIcon;
